<section class="col-12 h-100 d-flex flex-column justify-content-between">
    <div class="overflow-auto">
        <!-- Title -->
        <h2 class="assessment-text-grey-ten assessment-text-bold-16 mb-3">
            <span *ngIf="data?.anonymous">{{ 'ANONYMOUS.MODAL.ENABLE' | translate }}</span>
            <span *ngIf="!data?.anonymous">{{ 'ANONYMOUS.MODAL.DISABLE' | translate }}</span>
        </h2>

        <!-- Description -->
        <p class="assessment-text-grey-ten assessment-text-regular-14 mb-4">
            <span *ngIf="data?.anonymous">{{ 'ANONYMOUS.MODAL.TURNING_ON' | translate }}</span>
            <span *ngIf="!data?.anonymous">{{ 'ANONYMOUS.MODAL.TURNING_OFF' | translate }}</span> {{ 'ANONYMOUS.MODAL.DESCRIPTION_SUFFIX' | translate }}
        </p>

        <!-- Bullet Points -->
        <ul class="bullet-list mb-4">
            <li class="assessment-text-grey-ten assessment-text-regular-14 mb-3">
                <span class="assessment-text-semibold-14">{{ 'ANONYMOUS.MODAL.IDENTITY_PROTECTION' | translate }}:</span>
                Personal details (like names or emails) <span *ngIf="data?.anonymous">{{ 'ANONYMOUS.MODAL.IDENTITY_TEXT_SHOW' | translate }}</span><span *ngIf="!data?.anonymous">{{ 'ANONYMOUS.MODAL.IDENTITY_TEXT_HIDE' | translate }}</span> {{ 'ANONYMOUS.MODAL.IDENTITY_TEXT_END' | translate }}
            </li>
            <li class="assessment-text-grey-ten assessment-text-regular-14 mb-3" *ngIf="data?.anonymous">
                <span class="assessment-text-semibold-14">{{ 'ANONYMOUS.MODAL.PERMANENT_PRIVACY' | translate }}:</span>
                {{ 'ANONYMOUS.MODAL.PERMANENT_PRIVACY_TEXT' | translate }}
            </li>
            <li class="assessment-text-grey-ten assessment-text-regular-14" *ngIf="data?.anonymous">
                <span class="assessment-text-semibold-14">{{ 'ANONYMOUS.MODAL.LOCKED_ANONYMITY' | translate }}:</span>
                {{ 'ANONYMOUS.MODAL.LOCKED_ANONYMITY_TEXT' | translate }}
            </li>
            <li class="assessment-text-grey-ten assessment-text-regular-14" *ngIf="!data?.anonymous">
                <span class="assessment-text-semibold-14">{{ 'ANONYMOUS.MODAL.HISTORICAL_PRIVACY' | translate }}:</span>
                {{ 'ANONYMOUS.MODAL.HISTORICAL_PRIVACY_TEXT' | translate }}
            </li>

        </ul>
    </div>

    <!-- Action Buttons -->
    <div class="d-flex gap-3 w-100 mt-1">
        <button mat-buton class="btn-shade-2 px-3 w-100 assessment-text-semibold-14" (click)="onSubmit()">
            <span *ngIf="data?.anonymous">{{ 'ANONYMOUS.MODAL.MAKE_ANONYMOUS' | translate }}</span>
            <span *ngIf="!data?.anonymous">{{ 'ANONYMOUS.MODAL.MAKE_NON_ANONYMOUS' | translate }}</span>
        </button>
        <button mat-button class="btn-shade-1 px-3 w-100 assessment-text-semibold-14" (click)="closeAll()">{{ 'COMMON.CANCEL' | translate }}</button>
    </div>
</section>